import { Box, Dialog } from '@mui/material';
import React, { useState } from 'react';

import WsCustomAvatar from './WsCustomAvatar';

interface CircularImageProps {
  src?: string;
  alt?: string;
  size?: number;
}

const CircularImage: React.FC<CircularImageProps> = ({
  src,
  alt = 'Profile Picture',
  size = 52,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => src && setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        sx={{ width: size, height: size, cursor: src ? 'pointer' : 'text' }}
        onClick={handleOpen}
      >
        <WsCustomAvatar src={src} alt={alt} size={size} borderRadius="50%" />
      </Box>

      <Dialog open={open} onClose={handleClose} sx={{ borderRadius: 10 }}>
        <img src={src} alt={alt} style={{ width: '100%' }} />
      </Dialog>
    </>
  );
};

export default CircularImage;
